import React, { useState, useEffect, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import UserItem from './UserItem'
import Popup from 'reactjs-popup';

import { UserService } from '../../service/user.service';

import '../../../node_modules/reactjs-popup/dist/index.css';
import '../../../node_modules/ag-grid-community/styles/ag-grid.css';
import '../../../node_modules/ag-grid-community/styles/ag-theme-alpine.css';
import Loader from '../Loader';

const UserList = () => {
    const gridRef = useRef();
    const [rowData, setRowData] = useState();
    const [loading, setLoading] = useState(true);
    const [pageLoading, setPageLoading] = useState(false);

    const userService = new UserService();

    const gridCellRenderer = (params) => {
        if (params.value) {
            let _value = '<span title="' + params.value + '">' + params.value + '</span>';
            return <div dangerouslySetInnerHTML={{ __html: _value }}></div>;
        }
    }

    const editCellRenderer = (pram) => {
        return <Popup trigger={<i className="fa fa-edit"></i>} nested modal>{close => (<UserItem id={pram.data.id} callBack={reloding} onClose={() => { close(); }}></UserItem>)}</Popup>;
    };

    const columnDefs = [
        { headerName: 'Id', field: 'id', width: 75, suppressSizeToFit: true, filter: true, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'User Name', field: 'name', filter: true, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Email', field: 'email', filter: true, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Company', field: 'companyName', filter: true, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Application', field: 'application', filter: true, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Manager/Sponsor', field: 'managerName', filter: true, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Status', field: 'status', filter: true, width: 100, suppressSizeToFit: true, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Expires', field: 'passwordExpiresId', width: 90, sortable: false, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: '', field: 'edit-button', width: 25, suppressSizeToFit: true, sortable: false, cellRenderer: p => editCellRenderer(p), resizable: false }
    ];

    useEffect(() => {
        const fetchData = async () => {
            setPageLoading(true);
            try {
                const result = await userService.getFilteredUsers();
                if (result.status === 200) {
                    setRowData(result.data.data)
                    setLoading(false);
                    gridRef.current.api.sizeColumnsToFit();
                }
            } catch (error) {
                console.error(error);
            }
            setPageLoading(false);
        };

        fetchData();

    }, [loading]);

    const reloding = () => {
        setLoading(true);
    }

    const gridOptions = {
        columnDefs: columnDefs,
        pagination: true,
        rowSelection: 'single',
        enableFilter: true,
        cacheBlockSize: 25,
        paginationPageSize: 25,
        getRowHeight: (params) => 25
    }

    return (
        <div className="card">
            <h5 className="card-header py-3">
                <i className="fa fa-folder-open-o" aria-hidden="true"></i> Users
            </h5>
            <div className="card-body" style={{ height: "75vh" }}>
                {pageLoading && <Loader />}

                <div className="ag-theme-alpine" style={{ height: "100%" }}>
                    <AgGridReact ref={gridRef} className="gridBaseClass" rowData={rowData} gridOptions={gridOptions} />
                </div>

            </div>
        </div>
    );
};

export default UserList;
